import React from 'react';
import trafficLightIcon from '../../../images/tracker-light.svg';
import numberIcon from '../../../images/tracker-number.svg';
import fiverIcon from '../../../images/tracker-rating.svg';
import binaryIcon from '../../../images/tracker-yesno.svg';
import { Icon } from '../../ui';

interface ISelectedTracker {
  type: TrackerType;
  hasError: boolean;
  onClick: () => void;
  disabled?: boolean;
  'data-testid'?: string;
}

const SelectedTracker: React.FC<ISelectedTracker> = ({ type, hasError, disabled, ...rest }) => (
  <div
    className={`flex items-center pv2 pl2 mb3 br2 ${hasError ? 'bg-washed-red' : 'bg-near-white'}`}
    {...rest}
  >
    {type === 'FIVER' && (
      <>
        <img
          className="db flex-none br b--light-gray pr2"
          style={{ width: 60, height: 36 }}
          src={fiverIcon}
          alt=""
        />
        <div className="flex justify-between items-center w-100 ph3">
          <p className="mv0 f6">Rating</p>
          {!disabled && <Icon name="caret-left" size={24} className="rotate-270" color="red" />}
        </div>
      </>
    )}

    {type === 'BINARY' && (
      <>
        <img
          className="db flex-none br b--light-gray pr2"
          style={{ width: 60, height: 36 }}
          src={binaryIcon}
          alt=""
        />
        <div className="flex justify-between items-center w-100 ph3">
          <p className="f6 mv0">Yes/No</p>
          {!disabled && <Icon name="caret-left" size={24} className="rotate-270" color="navy" />}
        </div>
      </>
    )}

    {type === 'TRAFFIC_LIGHT' && (
      <>
        <img
          className="db flex-none br b--light-gray pr2"
          style={{ width: 60, height: 36 }}
          src={trafficLightIcon}
          alt=""
        />
        <div className="flex justify-between items-center w-100 ph3">
          <p className="f6 mv0">Traffic Light</p>
          {!disabled && <Icon name="caret-left" size={24} className="rotate-270" color="navy" />}
        </div>
      </>
    )}

    {type === 'INTEGER' && (
      <>
        <img
          className="db flex-none br b--light-gray pr2"
          style={{ width: 60, height: 36 }}
          src={numberIcon}
          alt=""
        />
        <div className="flex justify-between items-center w-100 ph3">
          <p className="f6 mv0">Number</p>
          {!disabled && <Icon name="caret-left" size={24} className="rotate-270" color="navy" />}
        </div>
      </>
    )}
  </div>
);

export default SelectedTracker;
